module.exports = __webpack_public_path__ + "img/desarrollo.ab68d991.svg";